import gql from 'graphql-tag';

export const FLOOR_PLANS_FRAGMENT = gql`
    fragment FLOOR_PLANS_FRAGMENT on ListingData {
        floorPlan {
            image {
                filename
                caption
            }
            links {
                url
                label
            }
            pdf {
                original
                caption
            }
        }
    }
`;
